import Vue from 'vue';
import { kebabCase } from 'lodash';

const requireComponent = require.context('.', true, /\.vue$/, 'lazy');

requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);
    const componentName =
        'module-' +
        kebabCase(
            fileName
                // remove file extension from the end
                .replace(/\.\w+$/, '')
        );
    Vue.component(componentName, () => componentConfig.then((m) => m.default));
});
